module.exports = __webpack_public_path__ + "img/a5f9500.svg";